<template lang="html">
  <div class="product-list">
    <skuList></skuList>
  </div>
</template>

<script>
import skuList from '@/components/product/index'

export default {
  created() {
    this.$$title('育儿服务')
    this.$$loading(false)
    const url = location.href
    this.$$share({
      webpageUrl: url,
      userName: 'gh_362b01c44275',
      path: `pages/mall-index/index?refererH5=${encodeURIComponent(url)}`,
      mpTitle: '育儿服务',
      thumbUrl:
        'https://cmspic-10004025.image.myqcloud.com/49f48940-80ec-11e8-8cd0-9b35661c25ba_size_340x360',
      mpType: 0 // 0 正式版，1 开发版， 2 体验版
    })
  },
  mounted() {
    this.$$allowRefreshOrShare(false, true)
  },
  components: {
    skuList
  }
}
</script>

<style lang="scss" scoped>
.product-list {
  padding-top: rem(20px);
}
</style>
